import { useMemo, useState } from "react"
import { formatPercent } from "atlas_forecasting_app/lib/format"
import { clampNumber } from "atlas_forecasting_app/lib/math"
import { useContainerWidth } from "atlas_forecasting_app/hooks/use_container_width"
import { ChartTooltip } from "atlas_forecasting_app/components/charts/chart_tooltip"

export function BinaryGaugeChart({ p, height }) {
  const [ref, width] = useContainerWidth()
  const [tooltip, setTooltip] = useState(null)
  const gradId = useMemo(() => `af_grad_${Math.random().toString(16).slice(2)}`, [])

  const view = 220
  const cx = 110
  const cy = 110
  const radius = 78
  const strokeWidth = 16
  const circumference = 2 * Math.PI * radius
  const dash = circumference * clampNumber(p, 0, 1)
  const gap = Math.max(0, circumference - dash)

  const onMove = (event) => {
    const rect = event.currentTarget.getBoundingClientRect()
    const x = event.clientX - rect.left
    const y = event.clientY - rect.top

    setTooltip({
      x,
      y,
      title: "Binary forecast",
      body: `Yes: ${formatPercent(p, 2)}\nNo: ${formatPercent(1 - p, 2)}`,
    })
  }

  return (
    <div ref={ref} className="af-chart" style={{ height: `${height}px` }}>
      {width > 0 ? (
        <svg width={width} height={height} viewBox={`0 0 ${view} ${view}`} onMouseMove={onMove} onMouseLeave={() => setTooltip(null)}>
          <defs>
            <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="rgba(34, 139, 230, 0.95)" />
              <stop offset="70%" stopColor="rgba(18, 184, 134, 0.90)" />
            </linearGradient>
          </defs>

          <circle cx={cx} cy={cy} r={radius} fill="none" stroke="rgba(134, 142, 150, 0.18)" strokeWidth={strokeWidth} />
          <circle
            cx={cx}
            cy={cy}
            r={radius}
            fill="none"
            stroke={`url(#${gradId})`}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={`${dash} ${gap}`}
            transform={`rotate(-90 ${cx} ${cy})`}
          />

          <text x={cx} y={cx - 4} textAnchor="middle" className="af-chart-axis" style={{ fontSize: "34px", fontWeight: 700 }}>
            {formatPercent(p, 1)}
          </text>
          <text x={cx} y={cx + 20} textAnchor="middle" className="af-chart-axis-muted">
            P(Yes)
          </text>
        </svg>
      ) : null}
      <ChartTooltip tooltip={tooltip} containerWidth={width} containerHeight={height} />
    </div>
  )
}
